import CONSTANTS from '../vars/CONSTANTS';

export default async function updateRemoteWishlist(gid) {
  if (!CONSTANTS.CUSTOMER_LOGGED_IN) return [];
  try {
    const res = await fetch(CONSTANTS.UPDATE_WISHLIST_URL, {
      method: 'POST',
      body: gid,
    });
    const data = await res.json();
    const products = data.metafield.value;
    return products;
  } catch (error) {
    console.error('[Wishlist] Failed to update wishlist', error);
    return [];
  }
}
